import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { accessories_arr } from "./Accessoriesdata";
import "./Accessories.scss";

const Accessories = () => {
  return (
    <section className="Accessories_Home">
      <Container>
        <div className="text-center">
          <article>
            {accessories_arr.map((state, index) => {
              return (
                <Link
                  to={`${state.type ==="Central Gases" ? "centralgas" : "accessories" }`}
                  state={{ type: state.type }}
                  key={index}
                  className="rounded"
                >
                  <div>
                    <img src={state.image} alt={state.accessoryType} className="rounded" />
                    <span className="d-flex justify-content-center align-items-center">
                      <p>{state.accessoryType}</p>
                    </span>
                  </div>
                </Link>
              );
            })}
          </article>
        </div>
      </Container>
    </section>
  );
};

export default Accessories;
